/* eslint max-len: 0 */
// TODO: eventually deprecate this console.trace("use the `babel-register` package instead of `babel-core/register`");
module.exports = require("babel-register");



//////////////////
// WEBPACK FOOTER
// ./~/babel-core/register.js
// module id = 797
// module chunks = 0